import {Pipe, PipeTransform} from '@angular/core';
import { valorSimNaoEnum } from '../dominios/enum/sim-nao.enum';

@Pipe({
    name: 'simNaoPipe'
})
export class SimNaoPipe implements PipeTransform {
    transform(value: string): string {
        return valorSimNaoEnum.Sim === Number(value) ? 'Sim' : 'Não';
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/sim-nao.pipe.ts